import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import HeritageSitesContext from "./contexts/HeritageSitesContext";
import ACCRPArchivalsContext from "./contexts/ACCRPArchivalDocsContext";
import TraumaInformedContext from "./contexts/TraumaInformedContext";
import InMemoriamContext from "./contexts/InMemoriamContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <HeritageSitesContext>
        <ACCRPArchivalsContext>
          <TraumaInformedContext>
            <InMemoriamContext>
              <App />
            </InMemoriamContext>
          </TraumaInformedContext>
        </ACCRPArchivalsContext>
      </HeritageSitesContext>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
